import { mapEnumToOptions } from '@abp/ng.core';

export enum TemplateState {
  Inactive = 0,
  Active = 1,
}

export const templateStateOptions = mapEnumToOptions(TemplateState);
